import Vue from "vue";
// https://github.com/euvl/vue-notification
import Notifications from 'vue-notification/dist/ssr.js';
// import { installMessage } from "./VMsg/index";
import './notification.scss';
Vue.use(Notifications);
// const notify = Vue.prototype.$notify;
// installMessage(Vue, notify);
